import React, { useState, useEffect } from 'react';
import './Rating.css';

export default function Rating() {
  const [reviews, setReviews] = useState([]);
  const [formData, setFormData] = useState({
    name: '',
    rating: '',
    comment: ''
  });

  // Load reviews from localStorage when the component mounts
  useEffect(() => {
    const storedReviews = localStorage.getItem('reviews');
    if (storedReviews) {
      setReviews(JSON.parse(storedReviews));
    }
  }, []);

  // Save reviews to localStorage whenever they are updated
  useEffect(() => {
    localStorage.setItem('reviews', JSON.stringify(reviews));
  }, [reviews]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.name && formData.rating && formData.comment) {
      setReviews([...reviews, formData]);
      setFormData({ name: '', rating: '', comment: '' });
    }
  };

  return (
    <div className="rating-container">
      <div className="rating-form">
        <h2>Submit Your Rating</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleInputChange}
            required
          />
          <select
            name="rating"
            value={formData.rating}
            onChange={handleInputChange}
            required
          >
            <option value="">Rate Us</option>
            <option value="1">1 Star</option>
            <option value="2">2 Stars</option>
            <option value="3">3 Stars</option>
            <option value="4">4 Stars</option>
            <option value="5">5 Stars</option>
          </select>
          <textarea
            name="comment"
            placeholder="Write your review"
            value={formData.comment}
            onChange={handleInputChange}
            required
          ></textarea>
          <button type="submit">Submit Review</button>
        </form>
      </div>

      <div className="reviews-display">
        <h2>Customer Reviews</h2>
        {reviews.length === 0 ? (
          <p>No reviews yet. Be the first to rate us!</p>
        ) : (
          reviews.map((review, index) => (
            <div className="review" key={index}>
              <h3>{review.name}</h3>
              <p>Rating: {"⭐".repeat(review.rating)}</p>
              <p>{review.comment}</p>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
